export default __webpack_public_path__ + "static/media/foreign-book-background-1.95caafe9.png";